<template>
    <div id="bsu-placeholder">
    </div>
</template>

<script setup>
  import { onMounted, onUnmounted } from 'vue';
  import { useRouter }              from 'vue-router';
  import SAPOMailConfig             from '@/SAPOMailConfig';

  const router         = useRouter();
  const conf           = SAPOMailConfig.server.bsu;

  onMounted(() => {
    setBSU();
    window.addEventListener('message', onLogout)
  })

  onUnmounted(() => {
    document.getElementById('bsuScript').remove();
    window.removeEventListener('message', onLogout);
  });

  const onLogout = (event) => {
    if (event.data.method && event.data.method === 'bsuLogOut') {
      logout();
    }
  }

  const logout = () => {
    router.push({ name: 'logout' });
  }

  const setBSU = () => {
    let script_element = document.createElement('script');
    script_element.setAttribute('async', true);
    script_element.setAttribute('data-spa', true);
    script_element.setAttribute('id', 'bsuScript');
    script_element.setAttribute('data-logout-url',
      window.location.origin + window.location.pathname + '#/logout'
    );

    for (let attr in conf.attrs) {
      script_element.setAttribute(attr, conf.attrs[attr]);
    }

    document.body.appendChild(script_element);
  }
</script>

<style>
  #bsuv3MailArea {
    display: none;
  }
</style>